import { createSimulateTransactions as createSimulateEVMTransactions } from '@exodus/web3-ethereum-utils'
import assert from 'minimalistic-assert'

export const createSimulateTransactions = ({ asset }) => {
  assert(asset, '"asset" should be passed.')

  const simulateEVMTransactions = createSimulateEVMTransactions({
    apiEndpoint: 'https://simulation.a.exodus.io/simulate',
    headers: {
      'X-Api-Version': '2023-06-05',
    },
  })

  return function simulateTransaction({ transactions, ...restParameters }) {
    return simulateEVMTransactions({ asset, transactions, ...restParameters })
  }
}
